import { render } from "./Index.vue?vue&type=template&id=9c6fb9e2&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=9c6fb9e2&scoped=true&lang=less"
import "./Index.vue?vue&type=style&index=1&id=9c6fb9e2&lang=less"

import exportComponent from "D:\\Project\\合肥客运\\官网\\开发\\前端\\hfky_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c6fb9e2"]])

export default __exports__